import { BaseCopyPaste } from '../base';
import { ClipboardType } from '../types';
import { SlideSizeType } from '@src/slide/domain/ui-model/element-modeles/property/slide-size/slide-size.interface';
import { IPcCopyPaste } from './pc-copy-paste.interface';
import { IHistoryManager } from '@src/slide/application/service/history-manager/core/history-manager.interface';
import { getDragPPTList, preventDefaultIfTypeIsFile } from '@src/slide/application/service/copy-paste/core/cp-ppt';
import { ENABLE_IMPORT_FILE } from '@src/framework/editor/src/js/constants/right-menu-data';
import Snackbar from '@tencent/dui/lib/components/Snackbar';
import i18n from '@i18next/i18n';
import { ISlideModel } from '@src/slide/domain/ui-model/element-modeles/Interface/slide-model.interface';
import { ImageCanvasOptions } from '@src/slide/application/service/copy-paste/core/plugin/types';
import {
    IPcEditorAreaService,
} from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-entry/edit-pc/pc-content-service.interface';

export class PcCopyPaste extends BaseCopyPaste implements IPcCopyPaste {
    private historyManager: IHistoryManager;

    public setHistoryManagerDelegate(historyManager: IHistoryManager): void {
        if (!this.historyManager) {
            this.historyManager = historyManager;
        }
    }

    public registerEventListener(): void {
        super.registerEventListener();
        window.addEventListener('dragover', this.handlerDragover.bind(this), true);
    }

    protected getAspectWIdthBySizeType(slideSizeType: SlideSizeType): number {
        const DPI_144_16_9_BASE_WIDTH = 1600;
        const DPI_144_4_3_BASE_WIDTH = 1200;
        const DPI_144_CUSTOM_BASE_WIDTH = 1100;
        switch (slideSizeType) {
            case SlideSizeType.SLIDE_SIZE_4_3:
                return DPI_144_4_3_BASE_WIDTH;
            case SlideSizeType.SLIDE_SIZE_16_9:
                return DPI_144_16_9_BASE_WIDTH;
            case SlideSizeType.SLIDE_SIZE_CUSTOM:
            default:
                return DPI_144_CUSTOM_BASE_WIDTH;
        }
    }

    protected shouldResponsePaste(event?: any): boolean {
        const isPcRightMenuPaste = !event;
        if (isPcRightMenuPaste) {
            this.services?.tipsManager?.showBrowserNotSupport();
            return false;
        }
        return super.shouldResponsePaste(event);
    }

    protected copyElementDataToImage(): void {
        const container = document.createElement('empty');
        this.copyDataToImage(container);
    }

    protected copySlideDataToImage(): void {
        const container = document.createElement('empty');
        this.copyDataToImage(container);
    }

    protected generateSlideCanvas(
        slideArray: ISlideModel[],
        imageCanvasOptions: ImageCanvasOptions,
    ): Promise<HTMLCanvasElement> {
        return (this.services?.contentRendererService as IPcEditorAreaService)
            .copyToImage.generateSlideCanvas(slideArray, imageCanvasOptions);
    }

    /**
     * 选区对应的dom元素，转图片写入剪贴板
     * @param { HTMLElement | null } container dom元素
     */
    private copyDataToImage(container: HTMLElement) {
        this.clipboardManager.save({
            [ClipboardType.IMAGE_PNG]: {
                container,
                outputOptions: this.getCopyCanVasOptions(),
            },
        });
    }

    private async handlerDragover(e) {
        const isPlaying = this.getPlayManager()?.isPlaying;
        if (isPlaying) return;  // 演示态不处理拖拽逻辑
        preventDefaultIfTypeIsFile(e);
        const { isShowHistoryPanel } = this.historyManager;
        const isImportFilePipelineFree = (await this.services?.importFilePipelineManager?.promise())?.isFree();
        // 历史面板打开、导入流程相关组件打开时，屏蔽事件
        if (!this.enable || isShowHistoryPanel || !isImportFilePipelineFree) return;
        // 检查是否有拖拽进来
        if (!this.dragStatus.isDragged) {
            this.dragStatus.isDragged = true;
            this.dragStatus.enableDrop = !![
                () => ({
                    result: this.getDragImgList(e),
                    type: 'img',
                }),
                () => ({
                    result: [...this.getDragVideoList(e), ...this.getDragAudioList(e)],
                    type: 'video/audio',
                }),
                () => ({
                    result: getDragPPTList(e),
                    type: 'ppt',
                }),
            ].find((fn) => {
                const dragRes = fn();
                if (!dragRes?.result?.length) return false;
                if (this.snackbarOp) this.snackbarOp.close();
                const snackbarInfoMap: Record<string, string> = {
                    img: this.getImgDragoverSnackbarMessage(),
                    ppt: i18n.t(dragRes.result.length > 1 ? '一次仅支持导入一个本地文档' : '拖动文件到正文，即可导入。'),
                    'video/audio': this.getAudioVideoDragoverSnackbarMessage(),
                };
                if (!ENABLE_IMPORT_FILE) {
                    snackbarInfoMap.ppt = '';
                }
                const message = snackbarInfoMap[dragRes.type];
                if (message) {
                    this.snackbarOp = Snackbar.show({
                        message,
                        duration: 3000,
                        autoClose: false,
                    });
                }
                return true;
            });
            return;
        }
    }
}
